import React, { useEffect, useState } from 'react'
import './TaskTagger.css'
import TaskTag from './TaskTag'

export default function TaskTagger({tags, selectTags}) {

  const [selected, setSelected] = useState([]);

  // EFFECT -- selected
  useEffect(()=>{
    if (selected) {
      selectTags(selected);
    }
  }, [selected, selectTags])

  //---[ OnClick ]---
  //
  const onAction = (tagName) => {
    console.log('[TaskTagger onAction] [tagName: %s]', tagName);
    const allSelected = new Set(selected);

    if (selected.includes(tagName)) {
      allSelected.delete(tagName);
    }
    else {      
      allSelected.add(tagName);
    }
    
    setSelected(Array.from(allSelected));
  }

  // ---[  OnRightClick  ]---
  //
  const onRightClick = (tagName) => {
    // Maybe the Opposite? ... turn ON ALL except this one?
  }


  // --- Render ---

  const tagsComp = tags.map(tag => <TaskTag tagTitle={tag} action={onAction} onRightClick={onRightClick} isSelected={selected.includes(tag)} key={tag}/>)

  return (
    <div className='taskTagger'>
      {tagsComp}
    </div>
  )
}
